import User from '@/assets/images/user.svg'
import IconCard from '@/components/UI/IconCard'
import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { useAppDispatch } from '@/hooks/redux'
import { useScreenOrientation, useScreenSize } from '@/hooks/screen'
import { setCurrentAuthProfile } from '@/redux/reducers/auth'
import { IProfile } from '@/types/profile'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ScrollView } from 'react-native'

interface AuthProfileListProps {
    profiles: IProfile[]
}

const AuthProfileList: FC<AuthProfileListProps> = ({ profiles }) => {
    const dispatch = useAppDispatch()

    const screenSize = useScreenSize()
    const screenOrientation = useScreenOrientation()

    const { t } = useTranslation()

    const handleProfilePress = (uuid: string) => {
        dispatch(setCurrentAuthProfile(uuid))
    }

    const marginTop = screenSize === 'small' && screenOrientation === 'landscape' ? 8 : 32

    return (
        <ScrollView style={{ marginTop }}>
            {profiles.length ? (
                profiles.map((profile) => (
                    <IconCard
                        key={profile.uuid}
                        title={profile.name}
                        subtitle={profile.description ?? undefined}
                        Icon={User}
                        onPress={() => handleProfilePress(profile.uuid)}
                    />
                ))
            ) : (
                <Typography.Description style={{ color: ColorEnum.WHITE, marginTop }}>
                    {t('profileSelectionScreenEmptyListMessage')}
                </Typography.Description>
            )}
        </ScrollView>
    )
}

export default AuthProfileList
